import React from 'react'
import { MainTabsContainer, MainTabsItem, MainTabsList, MainTabsSeparator } from './Theme'

const MainTabs = ({
  tabs,
  activeTab,
  onTabsChange,
  className,
}) => {
  return (
    <MainTabsContainer className={className}>
      <MainTabsList>
        {tabs.map((tab) => (
          <MainTabsItem
            key={tab.value}
            active={activeTab === tab.value}
            onClick={() => onTabsChange(tab)}
            width={tab.width}
          >
            {tab.title}
          </MainTabsItem>
        ))}
      </MainTabsList>
      <MainTabsSeparator />
    </MainTabsContainer>
  )
}

export default MainTabs